module.exports = __webpack_public_path__ + "img/99.cffd6660.jpg";